"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relatedProfileFactory = void 0;
const Factory = require("factory.ts");
const guardianship_factory_1 = require("./guardianship.factory");
const guardianship = guardianship_factory_1.guardianshipFactory.build();
exports.relatedProfileFactory = Factory.Sync.makeFactory({
    id: `user-profile-${Factory.each(i => i + 1)}`,
    access: 'viewer',
    relationship: 'other',
    guardianship_id: guardianship.id,
    guardianship: guardianship,
    persona: guardianship.persona,
    persona_id: guardianship.persona.id
});
